var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMapMarker = function SvgMapMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 0c7.74 0 14 6.26 14 14 0 10.5-14 26-14 26l-.824-.946C10.174 35.535 0 22.95 0 14 0 6.26 6.26 0 14 0m0 4C8.48 4 4 8.48 4 14c0 5.7 5.84 14.42 10 19.76l.838-1.08C18.959 27.28 24 19.388 24 14c0-5.52-4.48-10-10-10m0 5a5 5 0 1 1 0 10 5 5 0 0 1 0-10"
  })));
};
export default SvgMapMarker;